var _path, _path2, _path3, _rect, _path4, _path5, _rect2, _path6, _path7, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawGiftJoyKqz4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 499.977,
    viewBox: "0 0 800 499.977",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-571 -325.738)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,427.308A1.384,1.384,0,0,0,1.388,428.7H798.612a1.388,1.388,0,0,0,0-2.777H1.388A1.384,1.384,0,0,0,0,427.308Z",
    transform: "translate(571 396.757)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M321.689,499.366H72.5a18.068,18.068,0,0,1-18.047-18.048V18.047A18.068,18.068,0,0,1,72.5,0H321.689a18.068,18.068,0,0,1,18.047,18.047v463.27A18.068,18.068,0,0,1,321.689,499.366ZM72.5,2.333A15.732,15.732,0,0,0,56.782,18.047v463.27A15.732,15.732,0,0,0,72.5,497.032H321.689A15.732,15.732,0,0,0,337.4,481.318V18.047A15.732,15.732,0,0,0,321.689,2.333Z",
    transform: "translate(580.079 325.738)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H286.678V74.462H0Z",
    transform: "translate(633.833 531.674)",
    fill: "#e02365"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74.462,
    height: 497.032,
    transform: "translate(741.802 326.905)",
    fill: "#e02365"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.474,250.406a28.881,28.881,0,0,0,.892-6.2l90.46-82.383-77.752-37.972-34.267,91.38a27.359,27.359,0,0,0-11.276-.669l-34.016-90.71L85.763,161.826l86.9,79.145c-.056.736-.112,1.472-.112,2.223a28.889,28.889,0,0,0,.943,7.212c-53.27,16.648-75.078,66.923-75.078,66.923l66.9,54.245c-3.99-39.9,20.377-80.752,33.551-99.582.862.077,1.731.132,2.613.132s1.751-.055,2.613-.132c13.173,18.829,36.846,91.76,36.846,91.76l63.607-46.423s-21.808-50.275-75.078-66.923Z",
    transform: "translate(586.467 340.556)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243.9,360.7a5.6,5.6,0,0,1-2.377-.532,5.479,5.479,0,0,1-3.189-4.91c-.565-36.014-21.1-71.36-33.291-89.224a4.514,4.514,0,0,0-3.762-1.905h-.007a4.544,4.544,0,0,0-3.818,1.905c-12.19,17.863-32.726,53.21-33.291,89.224a5.48,5.48,0,0,1-3.189,4.91,5.539,5.539,0,0,1-5.878-.717L97.852,313.034a5.6,5.6,0,0,1-1.426-6.9c5.787-11.144,28.066-48.706,71.79-64.151a4.395,4.395,0,0,0,2.881-4.725,29.076,29.076,0,0,1-.214-3.489,4.6,4.6,0,0,0-1.433-3.441l-82.3-74.956a5.566,5.566,0,0,1,1.3-9.117l68.526-33.465a5.566,5.566,0,0,1,7.654,3.047L196.4,200.559a4.385,4.385,0,0,0,4.247,2.843,28.742,28.742,0,0,1,4.355.239,4.383,4.383,0,0,0,4.712-2.805L241.6,115.83a5.566,5.566,0,0,1,7.654-3.047l68.525,33.465a5.566,5.566,0,0,1,1.305,9.117L232.851,233.9a4.365,4.365,0,0,0-1.409,2.812c-.023.234-.047.467-.075.7h0a4.357,4.357,0,0,0,2.905,4.564c43.733,15.442,66.016,53.01,71.8,64.156a5.6,5.6,0,0,1-1.426,6.9L247.4,359.453a5.545,5.545,0,0,1-3.5,1.249Z",
    transform: "translate(585.228 344.45)",
    fill: "#e02365"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M672.594,451.032H432.172a18.069,18.069,0,0,1-18.048-18.048V310.656a18.069,18.069,0,0,1,18.048-18.048H672.594a18.068,18.068,0,0,1,18.047,18.048V432.984A18.068,18.068,0,0,1,672.594,451.032ZM432.172,294.942a15.732,15.732,0,0,0-15.715,15.715V432.984A15.732,15.732,0,0,0,432.172,448.7H672.594a15.732,15.732,0,0,0,15.714-15.715V310.656a15.732,15.732,0,0,0-15.714-15.715Z",
    transform: "translate(640.052 374.528)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 41.076,
    height: 158.144,
    transform: "translate(1175.491 667.276)",
    fill: "#e02365"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H274.184V41.076H0Z",
    transform: "translate(1055.344 726.837)",
    fill: "#e02365"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M534.485,393.642a16.139,16.139,0,0,0,3.463.5l46.039,50.552,21.22-43.45-51.066-19.15a15.289,15.289,0,0,0,.374-6.3l50.692-19.01-21.22-43.45L539.758,361.9c-.411-.031-.823-.063-1.242-.063a16.143,16.143,0,0,0-4.03.527c-9.3-29.769-37.4-41.956-37.4-41.956l-30.314,37.388c22.3-2.23,45.127,11.388,55.65,18.749-.043.482-.074.967-.074,1.46s.031.978.074,1.46c-10.522,7.362-33.351,20.979-55.65,18.749L497.086,435.6s28.1-12.187,37.4-41.956Z",
    transform: "translate(651.082 377.983)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M586.865,440.343a3.328,3.328,0,0,1-2.461-1.088l-43.323-47.571a2.272,2.272,0,0,0-1.465-.7l-.187-.019a2.19,2.19,0,0,0-2.355,1.395c-8.551,24.244-29.37,36.583-35.546,39.787a3.329,3.329,0,0,1-4.111-.865L471.808,399.7a3.319,3.319,0,0,1-.429-3.521,3.267,3.267,0,0,1,2.928-1.9c19.8-.305,39.251-11.606,49.085-18.315a2.348,2.348,0,0,0,0-3.763c-9.832-6.709-29.283-18.009-49.085-18.315a3.267,3.267,0,0,1-2.928-1.9,3.319,3.319,0,0,1,.429-3.521l25.61-31.585a3.339,3.339,0,0,1,4.11-.866c6.176,3.205,26.99,15.543,35.543,39.779a2.128,2.128,0,0,0,2.232,1.409,15.452,15.452,0,0,1,3.07-.087L584.4,310.953a3.33,3.33,0,0,1,5.455.782l18.463,37.805a3.329,3.329,0,0,1-1.824,4.579l-46.742,17.528a2.171,2.171,0,0,0-1.4,2.091l0,.338a16.329,16.329,0,0,1-.15,2.2,2.125,2.125,0,0,0,1.4,2.23L606.5,396.089a3.33,3.33,0,0,1,1.823,4.58l-18.463,37.805a3.338,3.338,0,0,1-2.994,1.869Z",
    transform: "translate(649.546 377.405)",
    fill: "#e02365"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(955.853 465.912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.037,152.553l6.465,29.078-37.883-6.29,15.437-27.5Z",
    transform: "translate(-326.557 -115.524)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.32,
    height: 53.754,
    transform: "translate(18.16 99.146)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.01,288.857l-7.99,42.858s5.085,29.782-10.17,60.291l-10.17,31.235-15.254-2.179s9.443-23.245,9.443-33.414,2.179-49.4,2.179-49.4l-1.09-44.76,33.051-4.636Z",
    transform: "translate(-324.922 -92.01)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.141,401.861s17.434-6.538,18.886,2.906l-.726,4.358s6.538,19.613-2.906,21.066-18.16,3.632-18.886-.726-.715-9.8,1.1-13.616S358.141,401.861,358.141,401.861Z",
    transform: "translate(-325.816 -73.535)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.492,283.159l-4.244,43.389s-13.167,27.193-7,60.741l1.082,32.831,15.259,2.149s-2.606-24.954.222-34.723,11.644-48.053,11.644-48.053L381.951,296.8l-30.458-13.645Z",
    transform: "translate(-328.393 -92.96)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.638,403.134s-14.928-11.128-18.949-2.462l-.514,4.389s-11.527,21.691-2.861,25.713,16.227,3.869,18.136-.115,3.412-9.214,2.735-13.384,1.453-14.141,1.453-14.141Z",
    transform: "translate(-329.147 -73.917)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.5,229.711l31.235,66.1s-62.834,31.6-99.88,31.6l18.395-97.7H398.5Z",
    transform: "translate(-329.853 -101.872)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.887,163.613l18.16,2.906-1.453,45.763,20.339,40.679-26.151,13.075s-20.339-38.5-23.971-62.471-1.453-41.4-1.453-41.4l14.528,1.453Z",
    transform: "translate(-326.208 -113.136)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,164.858l-18.16,2.906,1.453,45.763-4.358,42.131L345,267.28s20.339-38.5,23.971-62.471,1.453-41.4,1.453-41.4L355.9,164.858Z",
    transform: "translate(-329.022 -112.928)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,167.023l4-1.09s14.165-1.816,16.344,4,1.453,39.952,1.453,39.952,3.748,41.9-10.838,42.38-11.681-34.39-11.681-34.39Z",
    transform: "translate(-322.152 -112.551)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8,
    cy: 18.8,
    r: 18.8,
    transform: "translate(29.341 7.41)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.781,164.8c4.033-1.023,8.606,3.284,10.214,9.624a16.362,16.362,0,0,1,.184,7.726l1.733,7.206.127-.007,13.67,32.215a26.071,26.071,0,0,1-1.211,23.145c-2.412,4.2-5.577,7.018-9.294,4.138-6.168-4.779-10.2-32.143-12.036-47.861l-4.253-15.978a16.363,16.363,0,0,1-3.524-6.88c-1.609-6.337.357-12.3,4.39-13.327Z",
    transform: "translate(-324.521 -112.72)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.2,167.023l-4-1.09s-14.165-1.816-16.344,4-1.453,39.952-1.453,39.952-3.748,41.9,10.838,42.38,11.681-34.39,11.681-34.39Z",
    transform: "translate(-329.499 -112.551)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.817,164.8c-4.033-1.023-8.606,3.284-10.214,9.624a16.363,16.363,0,0,0-.184,7.726l-1.733,7.206-.127-.007-13.67,32.215a26.071,26.071,0,0,0,1.211,23.145c2.412,4.2,5.577,7.018,9.294,4.138,6.168-4.779,10.2-32.143,12.036-47.861l4.253-15.978a16.364,16.364,0,0,0,3.524-6.88c1.609-6.337-.357-12.3-4.39-13.327Z",
    transform: "translate(-328.536 -112.72)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.364,161.561c.956-2.908,7.232-4.232,7.431-7.693.443-7.712,12.213-27.55,18.932-31.36s10.579-2.662,17.424.917a21.772,21.772,0,0,1,7.46,2.254c4.137,2.042,7.861,5.314,9.47,9.638,1.275,3.427,1.134,7.191,1.56,10.823,1.187,10.119,6.859,19.742,5.642,29.857-.38,3.156-1.579,6.419-4.16,8.275s-6.749,1.654-8.448-1.033c-.58-.917-.825-2-1.321-2.969a2.971,2.971,0,0,0-2.478-1.833c-1.63.045-2.459,2.232-1.817,3.73s2.153,2.4,3.571,3.208a10.379,10.379,0,0,1-14.524-10.988c.766-5.162,4.159-5.344,5.045-10.487.645-3.744,7.036-8.757,6.42-12.506s-11.236-11.044-14.831-12.312a14.68,14.68,0,0,1-8.277-7.458c-3.812,5.527-7.166,4.026-8.532,10.6-.724,3.484,2.3,11.3,4.052,17.3a34.748,34.748,0,0,1,1.467,7.875s-4.044,3.73-5.1,6.241a15.467,15.467,0,0,1-1.979,4.16c-1.9,2.256-5.4,2.394-8.187,1.445a14.048,14.048,0,0,1-8.823-17.689Z",
    transform: "translate(-328.215 -120.142)",
    fill: "#2f2e41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawGiftJoyKqz4);
export default __webpack_public_path__ + "static/media/undraw_gift-joy_kqz4.7e2d2b588904e5228e0b75428e013792.svg";
export { ForwardRef as ReactComponent };